import { render, staticRenderFns } from "./AllClassesPage.vue?vue&type=template&id=fa6288be&scoped=true"
import script from "./AllClassesPage.vue?vue&type=script&lang=js"
export * from "./AllClassesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6288be",
  null
  
)

export default component.exports